module.exports = __webpack_public_path__ + "img/23-c482b7.png";